// ============================================================================
//  searchMatch — how a typed query picks a code out of a long catalogue
// ----------------------------------------------------------------------------
//  Kept in its own file, with NO imports of any kind, so it can be executed and
//  asserted directly by the backend test suite. Ranking rules are the kind of
//  thing that looks obviously right and is quietly wrong ("mal" not finding
//  Malaria), and asserting them against the source text proves nothing.
// ============================================================================

//  Lower is better. The intent: whatever the officer most likely meant is first.
export function rankOf(option, q) {
  const code = String(option.code == null ? '' : option.code).toLowerCase();
  const name = String(option.name == null ? '' : option.name).toLowerCase();
  if (code === q) return 0;               // typed the code exactly
  if (name === q) return 1;               // typed the whole name
  if (code.indexOf(q) === 0) return 2;    // code prefix — "OPDC0"
  if (name.indexOf(q) === 0) return 3;    // name prefix — "malar"
  if (name.indexOf(' ' + q) >= 0) return 4; // a whole word inside the name
  return 5;                                // matched somewhere
}

//  Every term must appear in the code or the name, in any order. That is what
//  lets "cast band" find "Bandaging / Cast Application" — a claims officer
//  half-remembering a procedure types the words they remember, not the prefix.
export function matchOptions(options, query) {
  const q = String(query == null ? '' : query).toLowerCase().trim();
  if (!q) return (options || []).slice();
  const terms = q.split(/\s+/).filter(Boolean);
  const hits = [];
  (options || []).forEach(function (o, i) {
    const hay = String(o.code == null ? '' : o.code).toLowerCase()
      + ' ' + String(o.name == null ? '' : o.name).toLowerCase();
    const all = terms.every(function (t) { return hay.indexOf(t) >= 0; });
    if (all) hits.push({ o: o, i: i, r: rankOf(o, q) });
  });
  //  Ties keep the catalogue's own order, which is alphabetical — so the list
  //  does not reshuffle unpredictably as you type.
  hits.sort(function (a, b) { return (a.r - b.r) || (a.i - b.i); });
  return hits.map(function (x) { return x.o; });
}
